import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import * as _ from "lodash";
import { Acesso } from 'src/app/core/acesso';
import { ToastService } from 'src/app/services/toast/toast.service';
import { Atendimento } from '../../../core/atendimento';
import { MetaAtendimento } from '../../../core/meta-atendimento';
import { MetaObjetivo } from '../../../core/metaObjetivo';
import { MetaObjetivoService } from '../../../services/metaObjetivo/meta-objetivo.service';


@Component({
    selector: 'formulario-atendimentos-metas',
    templateUrl: './formulario-atendimentos-metas.component.html',
    styleUrls: ['./formulario-atendimentos-metas.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FormularioAtendimentosMetasComponent implements OnInit {

    @Input() atendimentos: Atendimento[];
    @Input() metas: MetaAtendimento[];
    @Input() meta: MetaAtendimento;
    @Input() index: number;
    @Input() perfilAcesso: Acesso;

    idRandomico = Math.random();

    constructor(private drc: ChangeDetectorRef,
                private toastService: ToastService,
                private metaObjetivoService: MetaObjetivoService) {
    }

    ngOnInit(): void {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }

    deletar() {
        this.metas.splice(this.index, 1);
        this.toastService.showSucesso("Meta removida com sucesso.");
    }

    onValorChangeMeta(registro: any) {
        if (registro && registro.id) {
            const metaJaCadastrado = _.find(this.metas, (metasAtendimento: MetaAtendimento) => metasAtendimento.metaObjetivo?.id === registro.id);
            if (_.isEmpty(metaJaCadastrado)) {
                this.metaObjetivoService.getById(registro.id).subscribe((metaObjetivo: MetaObjetivo) => {
                    this.meta.metaObjetivo = metaObjetivo;
                })
            } else {
                this.toastService.showAlerta("Meta já adicionada.")
                this.metas.splice(this.index, 1);
                this.meta = new MetaAtendimento();
                this.metas.splice(this.index, 0, this.meta);
            }
        }
    }

}
